export default __webpack_public_path__ + "static/media/CONTENEDOR.adae7658.png";